import { render, staticRenderFns } from "./LayoutMobile.vue?vue&type=template&id=77174a07&scoped=true&"
var script = {}
import style0 from "./LayoutMobile.vue?vue&type=style&index=0&id=77174a07&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77174a07",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77174a07')) {
      api.createRecord('77174a07', component.options)
    } else {
      api.reload('77174a07', component.options)
    }
    module.hot.accept("./LayoutMobile.vue?vue&type=template&id=77174a07&scoped=true&", function () {
      api.rerender('77174a07', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/appointment/vrach/new/components/DoctorAppointmentForm/layouts/LayoutMobile.vue"
export default component.exports